import {
  ListGroup, Row, Col, Form
} from "react-bootstrap";

import IRegionHwrc from "interfaces/models/IRegionHwrc";

interface UserRegionItemProps {
  register : any;
  region: IRegionHwrc;
}

const UserRegionItem = ({
  register, region, ...props
} : UserRegionItemProps) => (
  <ListGroup.Item {...props}>
    <Row className="align-items-center">
      <Col xs={11}><Form.Label className="d-flex w-100 mb-0" htmlFor={`swRegion_${region.regionId}`}>{region.regionName}</Form.Label></Col>
      <Col xs={1} className="d-flex justify-content-end">
        <Form.Check
          {...register("regions")}
          id={`swRegion_${region.regionId}`}
          data-testid={`swAllocate_${region.regionId}`}
          className="d-inline-flex custom-switch custom-switch-md ms-2"
          type="switch"
          aria-required="false"
          aria-label={`${region.regionName} region`}
          value={region.regionId}
        />
      </Col>
    </Row>
  </ListGroup.Item>
);

export default UserRegionItem;
